import * as React from 'react';
import type { SVGProps } from 'react';
const SvgDonut = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={297}
    height={252}
    fill="none"
    {...props}
  >
    <path
      fill="#E2E2EB"
      d="M64.253 86.942a96.746 96.746 0 0 0 49.078 127.95 96.73 96.73 0 0 0 49.577 7.755l-4.595-42.708a53.785 53.785 0 0 1-49.262-21.852 53.78 53.78 0 0 1-5.591-53.6z"
    />
    <path
      fill="#EEEEF3"
      d="M161.948 222.763a96.744 96.744 0 0 0 71.078-150.01l-35.723 23.853a53.79 53.79 0 0 1-39.52 83.405z"
    />
    <path
      fill="#F6F6F9"
      d="M243.157 92.467a96.74 96.74 0 0 0-62.513-58.602 96.74 96.74 0 0 0-84.53 14.025l25.07 34.88a53.788 53.788 0 0 1 81.756 24.785z"
    />
    <path
      fill="#C5C6D6"
      d="M100.067 45.199A96.74 96.74 0 0 0 62.671 90.76l39.927 15.842A53.8 53.8 0 0 1 123.39 81.27z"
    />
  </svg>
);
export default SvgDonut;
